<div class="font-body-1 font-body-medium" data-testid="bound-products">
  @for (group of productGroups(); track group.key) {
    @if (group.routeLabel) {
      <fcom-tag [attr.data-testid]="'flight-route-tag-' + group.key">{{ group.routeLabel }}</fcom-tag>
    }
    @for (categoryGroup of group.categories; track categoryGroup.category) {
      <fin-shopping-cart-category-line
        [items]="categoryGroup.items"
        [category]="categoryGroup.category"
        [currencyCode]="currency()"
        [categoryTitle]="categoryGroup.categoryTitle"
        [bundleConstituentTitles]="categoryGroup.bundleConstituentTitles"
      />
    }
  }
</div>
